import { render, staticRenderFns } from "./regproject.vue?vue&type=template&id=3c11ed52&scoped=true"
import script from "./regproject.vue?vue&type=script&lang=js"
export * from "./regproject.vue?vue&type=script&lang=js"
import style0 from "./regproject.vue?vue&type=style&index=0&id=3c11ed52&prod&lang=scss&scoped=true"
import style1 from "./regproject.vue?vue&type=style&index=1&id=3c11ed52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c11ed52",
  null
  
)

export default component.exports